import { Progress } from 'antd';

import { type ProgressDetails } from './GenericProgressContext';
import { ProgressElement, ProgressWrapper, Summary } from './GenericProgressToast.style';

export function GenericProgressToast({
  description,
  totalQuantity,
  quantityCompleted,
}: ProgressDetails) {
  return (
    <ProgressElement>
      <span>{description}:</span>
      <ProgressWrapper>
        <Summary>
          {quantityCompleted} / {totalQuantity}
        </Summary>
        <Progress
          percent={Math.round((quantityCompleted / totalQuantity) * 100)}
          showInfo={false}
          status="active"
        />
      </ProgressWrapper>
    </ProgressElement>
  );
}
